import Vue from 'vue'
import {UserAvailability} from '../utilities/enums'
import {isEmpty} from '../utilities'
export const MessengerAPIClient = {
  getGroupInfo: function (groupId) {
    return new Promise((resolve, reject) => {
      Vue.http.get('/group/' + groupId).then(function (data) {
        resolve(data.data.Data);
      }).catch(function (error) {
        reject(error)
      })
    })
  },
  joinGroup: function (group){
    console.log('Group to join', group)
    return new Promise((resolve, reject)=>{
      Vue.http.put('/group/' + group.GroupId + '/join').then(function(data){
        resolve(data.data.Data)
      }).catch(function(error){
        reject(error)
      })
    })
  },
  sendMessage: function (sendPack) {
    console.log('Send Pack', sendPack)
    return new Promise((resolve, reject) => {
      Vue.http.post('/message/send', sendPack.ChatPackage).then((resp) => {
        resolve({
          Response: resp.data.Data,
          MessagePackage: sendPack,
          Success: resp.data.Data != null
        })
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getGroupUsers: function (group) {
    return new Promise((resolve, reject) => {
      Vue.http.get('/group/' + group + '/members').then(function (data) {
        resolve(data.data.Data)
      }).catch(function () {
        reject(error);
      })
    })
  },
  searchUsers: function (searchObj) {
    return new Promise((resolve, reject) => {
      let from = searchObj.from
      let size = searchObj.size
      let accountPlatformIds = searchObj.accountPlatformIds
      let orderBy = searchObj.orderBy
      let orderDir = searchObj.orderdir
      let search = searchObj.search
      let acctPlatString = ''
      accountPlatformIds.forEach(function (element) {
        acctPlatString = '&' + acctPlatString + 'accountPlatformId=' + element;
      })
      Vue.http.get('/core/users?from=' + from + '&size=' + size + acctPlatString + '&orderby=' + orderBy + '&orderdir=' + orderDir + '&search=' + search).then(function (data) {
        if (data.data.Data.length > 0) {
          resolve({
            results: data.data.Data,
            count: data.data.Data.length,
            totalResults: data.data.Data[0].MatchedCount
          })
        } else {
          resolve({
            results: data.data.Data,
            count: data.data.Data.length,
            totalResults: data.data.Data.length
          })
        }
      })
    })
  },
  addUserToGroup: function (groupId, userId) {
    return new Promise((resolve, reject) => {
      Vue.http.post('/group/' + groupId + '/' + userId).then(function (resp) {
        resolve(resp.data.Data)
      })
    })
  },
  getAnUser: function (userId) {
    return new Promise((resolve, reject) => {
      Vue.http.get('/users/' + userId).then(function (user) {
        resolve(user.data.Data)
      })
    })
  },
  uploadFiles: function (files, groupId) {
    return new Promise((resolve, reject) => {
      let toBeUploaded = [...files]
      let uploadPromises = []
      toBeUploaded.forEach(function (file) {
        let formData = new FormData();
        formData.append('file', file)
        //Upload File
        try {
          uploadPromises.push(Vue.http.post('/message/' + groupId + '/uploadFile', formData))
        } catch (e) {
        }
      })
    })
  },
  clockIn: function(){
    return new Promise((resolve,reject)=>{
      Vue.http.put('/users/clockin').then(function(data){
        resolve(data)
      }).catch(function(error){
        resolve(error)
      })
    })
  },
  setBusy: function(availabilityPayload){
    return new Promise((resolve,reject)=>{
      Vue.http.put('/users/busy/' + availabilityPayload.time, {
        AvailabilityReasonId: availabilityPayload.reason,
        Notes: availabilityPayload.note
      }).then(function(data){
        resolve(data.data.Data)
      }).catch(function(error){
        resolve(error)
      })
    })
  },
  setNotAvailable: function(availabilityPayload){
    return new Promise((resolve,reject)=>{
      Vue.http.put('/users/clockout').then(function(data){
        resolve(data.data.Data)
      })
    })
  },
  getAvailabilityReasons: function (){
    return new Promise((resolve,reject) =>{
      Vue.http('/users/availabilityReasons').then(function(data){
        resolve(data.data.Data)
      }).catch(function(error){
        reject(error)
      })
    })
  },
  setAvailability: function (availabilityPayload){
    let self = this;
    return new Promise((resolve, reject) =>{
      console.log(availabilityPayload.availability)
      if(availabilityPayload.availability == UserAvailability.Available){
        self.clockIn().then(function(data){
          resolve(data)
        }).catch(function(error){
          reject(error)
        })
      }
      else if(availabilityPayload.availability == UserAvailability.Busy){
        self.setBusy(availabilityPayload).then(function(data){
          resolve(data)
        }).catch(function(error){
          reject(error)
        })
      }
      else if(availabilityPayload.availability == UserAvailability.NotAvailable){
        self.setNotAvailable(availabilityPayload).then(function(data){
          resolve(data)
        }).catch(function(error){
          reject(error)
        })
      }
    })
  },
  postCustomerGroup: function (chatPackage){
    return new Promise((resolve,reject)=>{
      Vue.http.post('/message/send', chatPackage).then(function(data){
        if(!isEmpty(data.data.Data)){
          console.log(data.data.Data)
          console.log(data.data.Data != {}, 'What is this')
        resolve(data.data.Data)          
        }
        else
        {
          throw(data.data.Messages)
        }
      }).catch(function(error){
        console.log(error)
        reject(error)
      })
    })
  },
 markGroupAsRead: function (groupId, lastMessageId){
   return new Promise((resolve,reject)=>{
     Vue.http.put('/group/' + groupId + '/viewed/' + lastMessageId).then(function(data){
       console.log('group viewed')
       resolve()
     })
   })
 }
}



// WEBPACK FOOTER //
// ./src/lib/data_access/messenger.js